/** @jsxImportSource @emotion/react */
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { FormRow } from "../../../common/hook-form";
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { useGetCountries } from "../../../../service/api";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { cardBottomPadding } from "../../../../style-util";
import { TextInput } from "../../../../components/forms/inputs/TextInput";
import { SelectInput } from "../../../../components/forms/inputs/SelectInput";
import { useHandleFetchError } from "../../../../error-handler";

export const AppHomepageUpsertGeneralInfo = () => {
  const {
    data: countries,
    isLoading: countriesAreLoading,
    error: getCountriesError,
  } = useGetCountries();

  useHandleFetchError(getCountriesError);

  if (countriesAreLoading) {
    return null;
  }

  const countryOptions = (countries || [])
    .filter((c) => c.enabled)
    .sort()
    .map((o) => ({
      label: o.countryCode,
      value: o.countryCode,
    }));

  countryOptions?.unshift({
    label: "",
    value: "",
  });

  return (
    <CardContainer>
      <PageHeader
        title="General homepage settings"
        subtitle="Configure the general settings for this homepage."
      />
      <CardBody css={cardBottomPadding}>
        <FormRow>
          <TextInput
            label="Name"
            name="name"
            helperText="The internal name of the homepage. Can only be seen by admins."
          />
          <TextInput
            label="Title"
            name="title"
            helperText="The title that will appear in the top of the app homepage."
          />
        </FormRow>
        <FormRow>
          <TextInput
            label="Valid from"
            name="validFrom"
            helperText="Choose from what day the homepage should be visible in the app."
            type="datetime-local"
          />
          <TextInput
            label="Valid to"
            name="validTo"
            helperText="Choose the day the homepage should not be visible in the app anymore."
            type="datetime-local"
          />
        </FormRow>
        <FormRow>
          <TextInput
            label="External URL"
            name="tableBookingUrl"
            helperText="If this field is filled a secondary button will appear in the top of the homepage where you can redirect the user to an external link."
          />
          <SelectInput
            label="Country code"
            name="countryCode"
            helperText="Choose in what country this homepage should appear."
            options={countryOptions}
          />
        </FormRow>
        <TextInput
          label="Video URL"
          name="videoUrl"
          helperText="Enter the URL of the video that should be displayed on the homepage."
        />
      </CardBody>
    </CardContainer>
  );
};
